import { render, staticRenderFns } from "./PurchasePreview.vue?vue&type=template&id=05bd3216&scoped=true&"
import script from "./PurchasePreview.vue?vue&type=script&lang=js&"
export * from "./PurchasePreview.vue?vue&type=script&lang=js&"
import style0 from "./PurchasePreview.vue?vue&type=style&index=0&id=05bd3216&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05bd3216",
  null
  
)

export default component.exports